/* Luvlyn · Beluister de geluiden (/pages/natuurgeluiden; ontwerp: natuurgeluiden.html en js/geluiden.js).
   Alleen wat deze pagina extra doet. Het geluid (data-geluid), het mandje, de chat (ook een vraag uit een
   link, #welke-geluiden) en het binnenkomen doen assets/site.js en assets/beweging.js.
   1. Probeer het dak: de noot speelt het volgende geluid, de klok kiest een andere tijd, en Stop
      verschijnt zolang de noot speelt.
   2. Het vogelhuisje, de waaier: een kleur kiezen draait de waaier (die foto voorop, de volgende rechts
      erachter, de vorige links) en zet de naam, de zin, de prijs en de mandjesknop op die kleur. Een tik op
      een foto erachter kiest die kleur.
   3. Bij een uitverkochte kleur het mailveld "als hij er weer is" (snippets/terug-melding.liquid), zoals op de
      productpagina: tonen, met de naam en de tag van die kleur (audit 05-10-2026). Versturen doet de browser
      zelf (Shopify eist een hCaptcha-token, een fetch kan dat niet); Shopify stuurt terug naar deze pagina en
      toont de bevestiging. De gekozen kleur onthoudt dit script zolang het tabblad open is, zodat de
      bevestiging de goede kleur noemt. */
(() => {
  const $ = (s, el = document) => el.querySelector(s);
  const $$ = (s, el = document) => [...el.querySelectorAll(s)];
  const flits = el => { el.classList.remove('ng-flits'); void el.offsetWidth; el.classList.add('ng-flits'); };

  /* ---------- 1. probeer het dak ----------
     De noot heeft data-geluid met het vólgende geluid. assets/site.js speelt dat: zijn luisteraar zit op
     document en is eerder gezet, dus hij loopt eerst. Deze luisteraar (ook op document, daarna) zet het
     geluid erna klaar. Zo is elke tik "het volgende geluid", net als op het huisje. Stoppen gaat via het
     seintje 'geluid' van assets/site.js (detail.bron en detail.stop). */
  const GELUID = (() => { try { return JSON.parse($('#luvlyn-geluiden')?.textContent || '{}'); } catch { return {}; } })();
  const VOLGORDE = Object.keys(GELUID);
  $$('[data-ngw3]').forEach(el => {
    const noot = $('[data-ngw3-noot]', el), klok = $('[data-ngw3-klok]', el), stop = $('[data-ngw3-stop]', el);
    const geluidEl = $('[data-ngw3-geluid]', el), tijdEl = $('[data-ngw3-tijd]', el);
    if (!noot || !klok) return;
    const TIJDEN = (el.dataset.ngw3Tijden || '').split(',').map(t => t.trim()).filter(Boolean);
    const label = el.dataset.ngw3NootLabel || '';
    let t = Math.max(0, TIJDEN.indexOf(tijdEl.textContent.trim())), stopper = null;
    document.addEventListener('click', e => {
      if (!e.target.closest('[data-ngw3-noot]') || !el.contains(e.target)) return;
      const nu = noot.dataset.geluid;
      geluidEl.textContent = GELUID[nu]?.naam || nu;
      flits(geluidEl);
      if (!VOLGORDE.length) return;
      const volgende = VOLGORDE[(VOLGORDE.indexOf(nu) + 1) % VOLGORDE.length];
      noot.dataset.geluid = volgende;
      noot.setAttribute('aria-label', label.replace('[naam]', GELUID[volgende]?.naam || volgende));
    });
    klok.addEventListener('click', () => {
      if (!TIJDEN.length) return;
      t = (t + 1) % TIJDEN.length;
      tijdEl.textContent = TIJDEN[t];
      flits(tijdEl);
    });
    document.addEventListener('geluid', ({ detail: d }) => {
      if (d.wie && d.wie !== 'secties') return;
      const van = !!d.speelt && d.bron === noot;
      el.classList.toggle('speelt', van);
      stop.hidden = !van;
      stopper = van ? d.stop : null;
    });
    stop.addEventListener('click', () => { if (stopper) stopper(); });
  });

  /* ---------- 2. het vogelhuisje: de waaier en de kleur ---------- */
  const SLEUTEL = 'luvlyn-ng-terug';
  const bewaar = k => { try { sessionStorage.setItem(SLEUTEL, k); } catch {} };
  const bewaard = () => { try { return sessionStorage.getItem(SLEUTEL); } catch { return null; } };
  $$('[data-ng-koop]').forEach(blok => {
    const knoppen = $$('[data-ng-kleur]', blok);
    const terug = $('[data-terug]', blok), klaarTekst = blok.dataset.terugKlaarTekst || '';
    let aangemeld = terug && $('[data-terug-klaar]', terug)?.textContent.trim() ? (bewaard() || knoppen.find(x => x.hasAttribute('data-op'))?.dataset.ngKleur) : null;
    function zetTerug(b){
      if (!terug) return;
      const k = b.dataset.ngKleur, naam = b.dataset.naam, klaar = aangemeld === k;
      terug.hidden = !b.hasAttribute('data-op') && !klaar;
      $$('[data-terug-naam]', terug).forEach(n => { n.textContent = naam; });
      const tags = $('[data-terug-tags]', terug);
      if (tags) tags.value = `terug-op-voorraad, terug-${k}`;
      const vraag = $('[data-terug-vraag]', terug);
      if (vraag) vraag.hidden = klaar;
      const ok = $('[data-terug-klaar]', terug);
      if (ok) ok.textContent = klaar ? klaarTekst.replace('[naam]', naam) : '';
      const fout = $('[data-terug-fout]', terug);
      if (fout && !klaar) fout.textContent = '';
    }
    $('form[data-terug-form]', blok)?.addEventListener('submit', () => {
      const b = knoppen.find(x => x.getAttribute('aria-pressed') === 'true');
      if (b) bewaar(b.dataset.ngKleur);
    });
    const fotos = $$('[data-ngk4-foto]', blok), volgorde = fotos.map(f => f.dataset.ngk4Foto);
    $$('[data-ngk4-kies]', blok).forEach(o => o.addEventListener('click', () => {
      knoppen.find(x => x.dataset.ngKleur === o.dataset.ngk4Kies)?.click();
    }));
    knoppen.forEach(b => b.addEventListener('click', () => {
      const k = b.dataset.ngKleur, op = b.hasAttribute('data-op');
      knoppen.forEach(x => x.setAttribute('aria-pressed', String(x === b)));
      const i = volgorde.indexOf(k), n = volgorde.length;
      if (i > -1) fotos.forEach((f, j) => { f.dataset.plek = j === i ? 'voor' : j === (i + 1) % n ? 'rechts' : 'links'; });
      $$('[data-ng-kleur-naam]', blok).forEach(e => { e.textContent = b.dataset.naam; });
      $$('[data-ng-kleur-zin]', blok).forEach(e => { e.textContent = b.dataset.zin; });
      $$('[data-ng-prijs]', blok).forEach(e => { e.hidden = e.dataset.ngPrijs !== k; });
      $$('[data-ng-mand]', blok).forEach(m => {
        m.dataset.variant = b.dataset.variant;
        m.dataset.naam = b.dataset.naam;
        m.disabled = op;
        const t = $('[data-ng-mand-tekst]', m);
        if (t) t.textContent = op ? m.dataset.tekstOp : m.dataset.tekst;
      });
      zetTerug(b);
    }));
    // terug van een aanmelding: de kleur van toen weer kiezen en de bevestiging in beeld brengen
    if (aangemeld) {
      knoppen.find(x => x.dataset.ngKleur === aangemeld)?.click();
      terug.scrollIntoView({ block: 'center' });
    }
  });
})();
